import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FikoYTKokBilesenComponent } from '@/src/service/kok-bilesen/kok-bilesen.component';

@Component({
  selector: 'departman-kart-sade',
  standalone: true,
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="ui text-center fluid pb-2">
      <div class="ui primary label mini"> Departman Tanımı </div>
    </div>
    <div class="sk" [style.--sk-accent]="p()?.departmanRenk || '#00c853'">
      <div class="sk-icerik">
        <div class="sk-baslik">{{ p()?.departmanAdi || 'Isimsiz' }}</div>
        @if (p()?.departmanKodu) { <span class="sk-chip">{{ p().departmanKodu }}</span> }
        @if (p()?.yonetici) { <div class="sk-alt">{{ p().yonetici }}</div> }
      </div>
      <div class="sk-sag">
        <span class="sk-dot" [style.background]="p()?.aktif === false ? '#ff4d4f' : '#52c41a'"></span>
      </div>
    </div>
  `,
})
export class DepartmanKartSadeComponent extends FikoYTKokBilesenComponent {
  parametreler = input<any>();
  constructor() { super(); }
  p = computed(() => this.parametreler()?.ek || {});
}
